module.exports = __webpack_public_path__ + "static/img/10.14ecbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/10.png
// module id = LMxb
// module chunks = 2